import { GameData } from "../../../server/data/GameData";
import { Presentation } from "../../../../core/gameflow/controller/Presentation";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { PunkRocker } from "../../../PunkRocker";

export class ZeroBetPresentation extends Presentation {

    private nextMode:string = "";

    private ammFSLeft:number = 0;

    constructor() {
        super();
    }

    setGamedData(data: GameData): void {
        this.ammFSLeft = data.raw.freespinsLeft;
        this.nextMode = data.nextMode;
    }

    preStart(): void {
    }

    public createPresentation(enableSkip: Function) {
        // switch(this.nextMode){
        //     case "Respin":
        //         break;
        // }
        this.PresentationState.setInactive();
    }

    skip(): void {
    }

    done(): void {
        Logger.logDev("Sending ZeroBet");
        // this._gameData.saveLastStickes(false);
        // if (this.willUpdateZeroBet) {
        PunkRocker.keypadPlugin.setZeroBetSpinCounter(this.ammFSLeft-1);
        // }

        PunkRocker.waysCounter.UpdateFreeSpinCounter(this.ammFSLeft-1);

        SlotGame.apiPlugin.betHandler.zeroBet();
    }
}